"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#3901F1",
        d: "M9.99902 19.998C15.5213 19.998 19.998 15.5213 19.998 9.99902C19.998 4.47671 15.5213 0 9.99902 0C4.47671 0 0 4.47671 0 9.99902C0 15.5213 4.47671 19.998 9.99902 19.998Z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FFFBF6",
        d: "M10.9535 13.9598H5.9971C5.98164 13.9601 5.96631 13.9569 5.95224 13.9505C5.93816 13.9441 5.9257 13.9347 5.91574 13.9228C5.90579 13.911 5.8986 13.8971 5.89471 13.8821C5.89081 13.8672 5.89031 13.8515 5.89323 13.8363L6.85942 8.87406C6.86335 8.85612 6.87235 8.83968 6.88534 8.82669C6.89834 8.8137 6.91479 8.80472 6.93274 8.8008C6.95069 8.79688 6.96938 8.79819 6.98661 8.80457C7.00384 8.81096 7.01887 8.82215 7.02992 8.83683L11.0299 13.7991C11.0393 13.8142 11.0447 13.8313 11.0456 13.849C11.0466 13.8667 11.0431 13.8843 11.0355 13.9003C11.0279 13.9163 11.0164 13.9301 11.0021 13.9405C10.9878 13.9509 10.9711 13.9575 10.9535 13.9598Z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FFFBF6",
        d: "M5.905 6.46752H10.8614C10.8769 6.46725 10.8922 6.47042 10.9063 6.47682C10.9203 6.48322 10.9328 6.49268 10.9427 6.50451C10.9527 6.51634 10.9599 6.53024 10.9638 6.54521C10.9677 6.56017 10.9682 6.57581 10.9653 6.59099L10.005 11.5631C10.0006 11.5807 9.99147 11.5967 9.97855 11.6095C9.96563 11.6222 9.94943 11.6311 9.93176 11.6351C9.91409 11.6392 9.89563 11.6383 9.87845 11.6325C9.86127 11.6267 9.84604 11.6162 9.83445 11.6023L5.82857 6.62235C5.81567 6.60868 5.80727 6.59139 5.80448 6.57281C5.8017 6.55422 5.80466 6.53523 5.81298 6.51838C5.8213 6.50153 5.83458 6.48762 5.85102 6.47853C5.86747 6.46944 5.88631 6.4656 5.905 6.46752Z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FFFBF6",
        d: "M11.4611 6.46731C11.4392 6.46777 11.4181 6.47526 11.4008 6.48867C11.3835 6.50208 11.371 6.52071 11.3651 6.54179C11.3129 6.95569 11.3487 7.37595 11.4702 7.77504C11.5918 8.17413 11.7962 8.54303 12.0703 8.85759C12.3443 9.17215 12.6817 9.42525 13.0604 9.60032C13.439 9.7754 13.8504 9.86848 14.2676 9.87349H14.3715C14.3938 9.87472 14.4159 9.86757 14.4332 9.85344C14.4506 9.83931 14.4621 9.81921 14.4655 9.79705L15.1319 6.57314C15.1329 6.55876 15.1311 6.54432 15.1263 6.53069C15.1216 6.51706 15.1142 6.50454 15.1044 6.4939C15.0947 6.48326 15.0829 6.47471 15.0698 6.46879C15.0566 6.46287 15.0424 6.4597 15.028 6.45947L11.4611 6.46731Z"
      })]
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Recharge.js.map